import React from 'react';
import { GridColDef } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { useParams, useNavigate } from 'react-router-dom';
import { ShoppingCart } from "@mui/icons-material";
import CustomDataGrid from '../../../../components/ui/customDataGrid/customDataGrid.component';
import { ORDERED_PARTS_ENDPOINT } from '../../../../consts';
import styles from './orderedParts.module.css';
import { useHasPermission } from '../../../../contexts/auth';

export const OrderedParts = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const canViewOrderedParts = useHasPermission("service.view_orderedpart");

  const handleRowClick = (orderedPartId: string) => {
    navigate(`/service/stock-status/${id}/ordered-parts/${orderedPartId}`);
  };

  const columns: GridColDef[] = [
    {
      field: "id",
      headerName: "ID",
    },
    {
      field: "number",
      headerName: t("Number"),
    },
    {
      field: "status",
      headerName: t("Status"),
      valueGetter: (value, row) => row.status_display,
    },
    {
      field: "delivered_at",
      headerName: t("Delivered At"),
      editable: false,
      valueGetter: (value) => value || "-",
    },
    {
      field: "price_net",
      headerName: t("Price Net"),
      type: "number",
      editable: false,
    },
    {
      field: "vat",
      headerName: t("VAT"),
      type: "number",
      editable: false,
    },
    {
      field: "quantity",
      headerName: t("Quantity"),
      type: "number",
      editable: false,
    },
    {
      field: "total",
      headerName: t("Total"),
      type: "number",
      editable: false,
    },
    {
      field: "used_quantity",
      headerName: t("Used Quantity"),
      type: "number",
      editable: false,
    },
    {
      field: "ordered_by",
      headerName: t("Ordered By"),
      sortable: false,
      valueGetter: (value, row) => {
        const orderedBy = row.ordered_by;
        if (!orderedBy) return "-";
        const name = [orderedBy.first_name, orderedBy.last_name].filter(Boolean).join(' ');
        return name || orderedBy.email || "-";
      }
    },
  ];

  if (!canViewOrderedParts) {
    return null;
  }

  const orderedPartsUrl = id ? `${ORDERED_PARTS_ENDPOINT}?part=${id}` : ORDERED_PARTS_ENDPOINT;

  return (
    <Box className={styles.container}>
      <CustomDataGrid
        icon={<ShoppingCart />}
        title={t('Ordered Parts')}
        url={orderedPartsUrl}
        gridSettingsKey="ORDERED_PARTS"
        columns={columns}
        refreshEventName="orderedPartAdded"
        onRowClick={handleRowClick}
      />
    </Box>
  );
};
